class NeverError extends Error {
    constructor(value) {
        super(`Unknown RemoteData state: ${value}`);
    }
}
export var Kinds;
(function (Kinds) {
    Kinds["Initialized"] = "Initialized";
    Kinds["Pending"] = "Pending";
    Kinds["Failure"] = "Failure";
    Kinds["Success"] = "Success";
})(Kinds || (Kinds = {}));
export class Initialized {
    kind = Kinds.Initialized;
}
export class Pending {
    kind = Kinds.Pending;
}
export class Failure {
    error;
    kind = Kinds.Failure;
    constructor(error) {
        this.error = error;
        if (error === null || error === undefined) {
            throw new TypeError('Parameter "error" is required');
        }
    }
}
export class Success {
    data;
    kind = Kinds.Success;
    constructor(data) {
        this.data = data;
        if (data === null || data === undefined) {
            throw new TypeError('Parameter "data" is required');
        }
    }
}
export function fold(initialized, pending, failure, success) {
    return (state) => {
        switch (state.kind) {
            case Kinds.Initialized:
                return initialized();
            case Kinds.Pending:
                return pending();
            case Kinds.Failure:
                return failure(state.error);
            case Kinds.Success:
                return success(state.data);
            default:
                throw new NeverError(state);
        }
    };
}
export const isInitialized = (state) => state instanceof Initialized;
export const isPending = (state) => state instanceof Pending;
export const isFailure = (state) => state instanceof Failure;
export const isSuccess = (state) => state instanceof Success;
//# sourceMappingURL=index.js.map